import { TFunction } from "i18next";
import * as yup from "yup";

export interface ProfessionValidationSchemeProps {
  t: TFunction;
}

export const ProfessionValidationScheme = ({
  t,
}: ProfessionValidationSchemeProps) => {
  const requiredMsg = t("validations.required");

  return yup.object().shape({
      code: yup.string().required(requiredMsg),
      name: yup.string().required(requiredMsg)
  });
};